var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          order_column: "created_date_formatted",
          direction: "desc",
          route_name: "privacy_form",
          css_formats: {
            validated_date_formatted: function(name, model) {
              if (name) {
                return "badge badge-glow badge-" + model.status_label_validated
              } else {
                return ""
              }
            }
          }
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(actions) {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-row gap-2" },
                  [
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "privacy_form.handling",
                          expression: "`privacy_form.handling`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Tratar formulário",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Tratar formulário',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EditIcon" },
                      on: {
                        click: function($event) {
                          return _vm.handling(actions.row.id)
                        }
                      }
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "privacy_form.detail",
                          expression: "`privacy_form.detail`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Detalhar formulário",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Detalhar formulário',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EyeIcon" },
                      on: {
                        click: function($event) {
                          return _vm.detail(actions.row.id)
                        }
                      }
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "privacy_form.delete",
                          expression: "`privacy_form.delete`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Excluir formulário",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n              content: 'Excluir formulário',\n              delay: { show: 100, hide: 100 }\n            }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                      attrs: { icon: "Trash2Icon" },
                      on: {
                        click: function($event) {
                          return actions.methods.destroy(
                            actions.data[actions.indextr]
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }